import * as Act from '@/services/legal-ad-form/components/act';
import * as Company from '@/services/legal-ad-form/components/company';
import * as HeadOffice from '@/services/legal-ad-form/components/head-office';
import * as OwnerList from '@/services/legal-ad-form/components/owner-list';
import * as AuditorInformation from '@/services/legal-ad-form/components/auditor-information';
import { trimObject } from '@/shared/utils';

export default {
  id: 'sccv',
  label: 'Avis de constitution SCCV',
  shortLabel: 'Avis de constitution',
  componentsData: {
    act: { type: '' },
    company: { legalForm: 'Société civile de construction vente' },
    headOffice: {},
    ownerList: [],
    mainAuditor: {},
    alternateAuditor: {},
    auditorInformation: {}
  },
  component: () => import('@/components/legal-ads/forms/models/registration/sccv.vue'),
  validate(modelData) {
    return trimObject({
      act: Act.validate(modelData.act),
      company: Company.validate(modelData.company, { add: ['sharesTransferClause'] }),
      headOffice: HeadOffice.validate(modelData.headOffice),
      ownerList: OwnerList.validate(modelData.ownerList),
      ...AuditorInformation.validate(modelData)
    });
  },
  buildContent(modelData) {
    return [
      Act.buildContent(modelData.act, 'société'),
      Company.buildContent(modelData.company),
      HeadOffice.buildContent(modelData.headOffice),
      OwnerList.buildContent(modelData.ownerList),
      AuditorInformation.buildContent(modelData),
      HeadOffice.buildRegistrationContent(modelData.headOffice),
    ].flat().join("\n").replace(/undefined/g, '?');
  }
};